import { createContext } from "react";

export const PlayersContext = createContext({
  playersData: [],
  globalData: null
});